/**
 * interval by requestAnimationFrame
 *
 * 按照屏幕刷新率回调，更稳定的轮询回调
 *
 * @authors Luo-jinghui (luojinghui424@gmail.com)
 * @date  2020-10-12 15:44:10
 */

const XYTimer = {
  timer: {},

  /**
   * 启动基于requestAnimation的轮询定时器
   *
   * @param key 定时器key值
   * @param cb 定时器调用函数
   * @param interval 多久触发一次定时器调用
   */
  setInterval(key = '', cb = () => {}, interval = 1000) {
    if (!key || typeof key !== 'string') {
      return 'Not find kye value';
    }

    const timerObj = this.timer[key];

    if (timerObj) {
      this.clearInterval(key);
    }

    let now = Date.now;
    let stime = now();
    let etime = stime;
    let loop = () => {
      this.timer[key] = {
        type: 'interval',
        key,
        id: requestAnimationFrame(loop),
      };

      etime = now();

      if (etime - stime >= interval) {
        stime = now();
        etime = stime;
        cb();
      }
    };

    this.timer[key] = {
      type: 'interval',
      key,
      id: requestAnimationFrame(loop),
    };

    return this.timer[key];
  },

  getTimers() {
    return this.timer;
  },

  clearInterval(key) {
    const interval = this.timer[key];

    if (interval && interval.id) {
      cancelAnimationFrame(interval.id);
    }

    if (interval) {
      delete this.timer[key];
    }
  },

  clearAll() {
    const timerKeys = Object.keys(this.timer);

    timerKeys.forEach((key: string) => {
      if (this.timer[key].type === 'interval') {
        this.clearInterval(key);
      }
    });
  },
};

export { XYTimer };
